import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/otrosEquipos/EquipoOilGas/OilGas1.png';
import Img2 from '../../img/products/otrosEquipos/EquipoOilGas/OilGas2.png';

const EquipoOilGas = () => {
    const navigate = useNavigate();

    return (
        <div className="container my-5">
            <h2 className="mb-4 text-center">Equipos para Oil & Gas</h2>
            <div className="row align-items-start mb-2">
                {/* Columna Izquierda: texto descriptivo */}
                <div className="col-md-7">
                    <p className="lead text-justify">
                        El equipo de bombeo para la industria del petróleo y gas es esencial para la extracción, 
                        transporte y procesamiento de hidrocarburos. Estos equipos están diseñados para manejar 
                        fluidos a altas presiones y temperaturas, y son fundamentales en cada etapa de la 
                        producción de petróleo y gas.
                    </p>
                    <p className="lead text-justify">
                        Utilizadas para la circulación de lodo de perforación y la eliminación de recortes durante 
                        la exploración y perforación.
                    </p>
                </div>
                {/* Columna derecha: imágenes en cuadrícula */}
                <div className="col-md-5">
                    <div className="row g-2">
                        <div className="col-6">
                            <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Oil&Gas 1" />
                        </div>
                        <div className="col-6">
                            <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Oil&Gas 2" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EquipoOilGas;
